import React, { useState } from "react";
import { writeContract, waitForTransaction } from "@wagmi/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { stakingAddress, stakingABI } from "../../constants/constant";

const notify = (isError, msg) => {
  if (isError) {
    toast.error(msg, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    toast.success(msg, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

const Block5 = ({
  setDialog5,
  targetIndex,
  targetClaimable,
  getStakingData,
}) => {
  const [loading, setLoading] = useState(false);
  const handleDialog5Close = () => {
    setDialog5(false);
  };

  const claim = async () => {
    try {
      setLoading(true);
      try {
        const { hash } = await writeContract({
          address: stakingAddress,
          abi: stakingABI,
          functionName: "claimRewards",
          args: [targetIndex],
        });
        const res = await waitForTransaction({
          hash,
          confirmations: 0,
        });
        setLoading(false);
        handleDialog5Close();
        notify(false, `Claimed`);
        getStakingData();

        if (!hash) {
          setLoading(false);
          notify(true, `Please confirm transaction.`);
          return;
        }
        notify(false, `Please wait till the transaction is confirmed.`);

        if (res.transactionHash !== hash) {
          setLoading(false);
          notify(true, `Transaction failed! Please try again later.`);
          return;
        }
      } catch (err) {
        notify(true, `Reward token balance is insufficient.`);
        setLoading(false);
      }
    } catch (err) {
      notify(true, `Reward token balance is insufficient.`);
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="md:h-auto h-auto md:w-[500px] w-[280px]  md:p-5 p-3"
        style={{
          background: "linear-gradient(90deg, #000 0%, #8437FA 230.49%)",
        }}
      >
        <div className="flex justify-start items-center">
          <p className="md:text-[24px] text-[16px]">Claim Rewards</p>
        </div>

        <div className="flex justify-center items-center md:h-[150px] h-[200px] w-full">
          <p className="text-[16px] font-[500]">
            You can still claim your TOKEN any time you want, your rewards are
            safe and you will not lose earned rewards even if you unstake your
            BRISE.
          </p>
        </div>

        <div className="flex justify-between items-center mt-3">
          <p className="text-[18px] font-[200] ">{targetClaimable}</p>
          <p className="h-[24px] w-[130px] text-end"> BEFE</p>
        </div>

        <div
          onClick={claim}
          className="h-[50px] w-full border border-[#8437FA] mt-8 flex justify-center items-center cursor-pointer"
        >
          {!loading ? (
            <p className="text-[14px]">Confirm Claim Rewards</p>
          ) : null}
          {loading ? (
            <svg
              aria-hidden="true"
              className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : null}
        </div>

        <div
          onClick={handleDialog5Close}
          className="h-[50px] w-full border border-[#8437FA] mt-2 flex justify-center items-center cursor-pointer"
        >
          <p className="text-[14px] ">Cancel</p>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default Block5;
